import React, { useState, useRef, useEffect } from "react";
import Service from "./Service.component";
import WebData from "../../Helpers/WebData";
import "./Services.style.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import ReactHtmlParser from "react-html-parser";

function Services() {
  const [serviceIndex, setServiceIndex] = useState(0);

  const contentRef = useRef(null);
  const textRef = useRef(null);

  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const onScroll = (ev) => {
    const scrollY = ev.target.scrollTop;
    const contentHeight = ev.target.offsetHeight;
    const textHeight = textRef.current.offsetHeight;

    const scrolled = scrollY / (textHeight - contentHeight);

    scrolled <= 0.0 ? setCanScrollUp(false) : setCanScrollUp(true);
    scrolled >= 1.0 ? setCanScrollDown(false) : setCanScrollDown(true);
  };

  useEffect(() => {
    setCanScrollDown(
      textRef.current.offsetHeight > contentRef.current.offsetHeight
    );
    contentRef.current.addEventListener("scroll", onScroll);
  }, []);

  // Actions
  const scrollUp = () => {
    contentRef.current.scrollTop -= 200;
  };

  const scrollDown = () => {
    contentRef.current.scrollTop += 200;
  };

  const selectService = (index) => {
    setServiceIndex(index);
    contentRef.current.scrollTop = 0;
  };

  return (
    <section className="services top-nav-space" id="services">
      <h3 className="global-heading text-center title-scroll">Service</h3>
      <p className="px-2">{WebData.categories.desc}</p>
      <div className="service-swiper-wrapper">
        <Swiper slidesPerView={"auto"}>
          {WebData.categories.items.map((item, index) => {
            return (
              <SwiperSlide key={index}>
                <Service
                  key={index}
                  isSelected={index === serviceIndex}
                  image={item.imageUrl}
                  text={item.categoryName}
                  onClick={() => selectService(index)}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="service-card">
          <div className="card-img">
            <img src={WebData.categories.items[serviceIndex].images} alt="" />
          </div>
          <div className="card-text-wrapper">
            <div ref={contentRef} className="card-text scrollbar-hide">
              <p ref={textRef}>
                {ReactHtmlParser(WebData.categories.items[serviceIndex].desc)}
              </p>
            </div>
            <div className="scroll-icon-container">
              <div
                onClick={scrollUp}
                className={
                  "scroll-icon scroll-up " +
                  (canScrollUp ? " " : "icon-disable")
                }
              >
                <svg viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
                  />
                </svg>
              </div>
              <div
                onClick={scrollDown}
                className={
                  "scroll-icon scroll-down " +
                  (canScrollDown ? "" : "icon-disable")
                }
              >
                <svg viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
